import BuyCouponCodeModal from "../../../Modals/buy-coupon-code-modal/buy-coupon-code-modal";
import {useState} from "react";
import PrimaryButton from "../../../components/Buttons/primary-button";

export default function BuyCouponSection({className, ...props}) {
    const [isOpen, setOpen] = useState(false);
    return (
        <section
            id={"buy-coupon-section"}
        >
            <div

                className={"justify-center flex-col px-4 box-border py-[32px] lg:py-[132px] bg-[#F9FAFB] items-center flex"}>

                <BuyCouponCodeModal
                    isOpen={isOpen}
                    setOpen={setOpen}
                />
                <div className={"flex flex-col   gap-4 px-4"}>
                    <div className={"flex flex-col lg:flex-row gap-20"}>
                        <div className={"flex justify-center self-center items-center "}>
                            <img
                                className={"lg:w-[450px] w-full h-auto shadow-md border-[1px] rounded-[16px]  lg:h-auto   object-contain"}
                                alt={"certificate"}
                                src={"/gold-partner.jpg"}
                            />
                        </div>
                        <div
                            className={` ${className} w-full lg:w-[704px] `}>

                            <div className={"flex flex-col gap-[12px]"}>
                                <p
                                    style={{
                                        lineHeight: "120%"
                                    }}
                                    className={"font-semibold text-[24px] lg:text-[48px]"}>
                                    Official Duolingo English Test Partner
                                </p>
                                <p
                                    style={{
                                        lineHeight: "160%"
                                    }}
                                    className={"text-[12px] lg:text-[20px]  text-[#344054]"}>
                                    Get 10% off your DET exam — plus free VIP access to DET Study’s premium practice
                                    suite.
                                </p>

                            </div>

                            <div className={"py-[24px] flex items-center flex-row gap-[62px]"}>
                                <div className={"flex flex-col gap-[8px]"}>
                                    <p
                                        style={{
                                            lineHeight: "120%"
                                        }}

                                        className={"font-semibold text-[20px] lg:text-[32px] text-[#0C98FE]"}>
                                        1 test — $63
                                    </p>

                                    <p
                                        style={{
                                            lineHeight: "160%"
                                        }}
                                        className={"text-[10px] lg:text-[20px] "}>

                                        (Official price: $70)
                                    </p>

                                </div>

                                <img
                                    src={"/owl.png"}
                                    alt={"Owl Image"}
                                    className={"w-[100px] lg:w-[147px] h-auto"}
                                />

                            </div>

                            <div className={"flex flex-col gap-[12px]"}>
                                <p className={"font-[500px] text-[20px] lg:text-[24px]"}>
                                    Bonus Offerings:
                                </p>
                                <div className={"flex flex-col gap-[16px]"}>
                                    {
                                        [
                                            "Instant delivery + get your test results in 24 hours (a $39 value — free)",
                                            "Receive Duolingo’s response to test issues within 48 hours",
                                            "Get 60-day VIP access to DET Study’s full premium platform (a $17.99 value — free)",
                                        ].map(
                                            (item, index) => (
                                                <p key={index}
                                                   className={"text-[12px] lg:text-[18px] last:font-semibold"}
                                                   style={{
                                                       lineHeight: "120%"
                                                   }}
                                                >
                                                    {item}

                                                </p>
                                            )
                                        )
                                    }

                                </div>

                            </div>

                            <PrimaryButton
                                onClick={() => setOpen(true)}
                                className={"!bg-[#0BA902] hover:!bg-[#0A9602] text-white mt-[40px]"}
                            >
                                Get Coupon + Free VIP Access
                            </PrimaryButton>

                        </div>
                    </div>


                </div>
            </div>
        </section>
    )
}